"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
var deleteFolderOperation_1 = require("owa-service/lib/operation/deleteFolderOperation");
var folderId_1 = require("owa-service/lib/factory/folderId");
var deleteFolderRequest_1 = require("owa-service/lib/factory/deleteFolderRequest");
function deleteFolderService(deleteFolderId, permanentlyDelete) {
    return deleteFolderOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: deleteFolderRequest_1.default({
            DeleteType: permanentlyDelete ? 'SoftDelete' : 'MoveToDeletedItems',
            FolderIds: [folderId_1.default({ Id: deleteFolderId })],
        }),
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = deleteFolderService;
//# sourceMappingURL=deleteFolderService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/services/deleteFolderService.js
// module id = 4732
// module chunks = 23